import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const MyAccountView = loadView('my-account/MyAccountView');

const myAccountRoute = {
  path: ROUTE.PATH.MY_ACCOUNT,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [
      PRESCREENING.APPROVAL_KEY.COMPLETED,
      PRESCREENING.APPROVAL_KEY.REJECTED,
      PRESCREENING.APPROVAL_KEY.TODO,
    ],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.MY_ACCOUNT,
      component: MyAccountView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [
          PRESCREENING.APPROVAL_KEY.COMPLETED,
          PRESCREENING.APPROVAL_KEY.REJECTED,
          PRESCREENING.APPROVAL_KEY.TODO,
        ],
      },
    },
    {
      path: ROUTE.PATH.MY_ACCOUNT,
      name: ROUTE.NAME.MY_ACCOUNT,
      component: MyAccountView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [
          PRESCREENING.APPROVAL_KEY.COMPLETED,
          PRESCREENING.APPROVAL_KEY.REJECTED,
          PRESCREENING.APPROVAL_KEY.TODO,
        ],
      },
    },
  ],
};

export default myAccountRoute;
